import { render } from "./footerHome.vue?vue&type=template&id=04183fb4&scoped=true"
const script = {}

import "./footerHome.vue?vue&type=style&index=0&id=04183fb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04183fb4"],['__file',"src/components/global/footerHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04183fb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04183fb4', __exports__)) {
    api.reload('04183fb4', __exports__)
  }
  
  module.hot.accept("./footerHome.vue?vue&type=template&id=04183fb4&scoped=true", () => {
    api.rerender('04183fb4', render)
  })

}


export default __exports__